import React from "react"
import { graphql } from "gatsby"

import { FaTwitterSquare, FaGithubSquare, FaDev, FaLinkedin } from "react-icons/fa";

import Layout from "../components/layout"

import SEO from "../components/seo"
import '../styles/contact.css';

class Contact extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="Contact" />
        <h1 className="contact-title">Contact</h1>
        <section>
          <p>Want to connect? You can find me online on these platforms:</p>
        </section>
				<main className="contact-content">
          <a className="contact-link" href="https://twitter.com/henningamy"><FaTwitterSquare className="contact-icon" aria-label="Twitter" /></a>
          <a className="contact-link" href="https://github.com/amyhenning"><FaGithubSquare className="contact-icon" aria-label="Github" /></a>
          <a className="contact-link" href="https://dev.to/amyhenning"><FaDev className="contact-icon" aria-label="DEV.to" /></a>
          <a className="contact-link" href="https://www.linkedin.com/in/amymhenning/"><FaLinkedin className="contact-icon" aria-label="LinkedIn" /></a>
				</main>
      </Layout>
    )
  }
}

export default Contact

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
